// extracted by mini-css-extract-plugin
module.exports = {"tags":"D_cn","tags__item":"D_cp"};